import styled from 'styled-components';

import { INDICATOR_SIZE } from '../../Stepper.constants';

export const Delimiter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  bottom: 0;

  width: ${INDICATOR_SIZE};

  &:before {
    content: '';
    width: 2px;
    height: 100%;
    background-color: var(--color-grey-3);
  }
`;
